// extracted by mini-css-extract-plugin
export default {"divider":"styles_divider__q4bVV"};